export const config = {
  description: (
    <>
      Design 991 is a marketplace offering online courses on UI, UX, marketing
      design, and a variety of other topics created by practicing industry
      professionals.
      <br />
      <br />
      Its key advantage lies in enabling users to chat, send their works to get
      reviews from experienced mentors, and share design ideas with other
      enthusiasts.
      <br />
      <br />
      We started the project by conducting research to understand the needs and
      preferences of the target audience. We also looked at existing e-learning
      platforms to identify design patterns and best practices. Based on this
      research, we developed a visual design concept that focused on simplicity,
      clarity, and consistency.
    </>
  ),
}
